import {Autocomplete, createFilterOptions} from "@material-ui/lab";
import {TextField} from "@material-ui/core";
import React from "react";

const AutoCompleteInput = (props) => {
const {
    field,
    label,
    open,
    handleOpen,
    selectedValues,
    options,
    multiple,
    handleOnChangeAutocomplete,
    handleInputChangeAutocomplete,
    onTextFieldBlur,
    disabled,
    chipStyle,
    getOptionLabel: getOptionLabelProp,
    getOptionDisabled,
} = props;

const defaultGetOptionLabel = (option) => option.name || '';
const getOptionLabel = getOptionLabelProp || defaultGetOptionLabel;

    return (
        <Autocomplete
            disabled={disabled}
            className={props.className}
            multiple={multiple}
            name={field}
            open={open}
            onOpen={(event) => handleOpen(true)}
            onClose={(event) => handleOpen(false)}
            onChange={(event, value) => handleOnChangeAutocomplete(field, value)}
            getOptionSelected={(option, value) => option.id === value?.id}
            getOptionLabel={getOptionLabel}
            getOptionDisabled={getOptionDisabled}
            value={selectedValues}
            options={options}
            ChipProps={chipStyle ? {style: chipStyle} : null}
            required={props.required}
            ListboxComponent={props.ListboxComponent}
            autoHighlight={props.autoHighlight}
            renderInput={(params) => (
                <TextField
                    {...params}
                    variant={props.variant}
                    placeholder={props.placeholder}
                    label={label}
                    onChange={(event) => handleInputChangeAutocomplete(event,field)}
                    error={props.error}
                    helperText={props.helperText}
                    onBlur={onTextFieldBlur ? onTextFieldBlur : null}
                />
            )}
        />
    )
}
export default AutoCompleteInput;